"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var BUTTON_HEIGHT = 32;
var HEADING_CONTENT_WRAPPER_CLASS = "accordion-widget-heading__content";
var withCentredAccordionButton = function (Comp) {
    var WithCentredButton = (function (_super) {
        __extends(WithCentredButton, _super);
        function WithCentredButton(props) {
            var _a, _b;
            var _this = _super.call(this, props) || this;
            _this.buttonTopMargin = 0;
            _this.repositionButton = function () {
                var element = _this.containerRef.current;
                var headingTextElement = element === null || element === void 0 ? void 0 : element.querySelector(".".concat(HEADING_CONTENT_WRAPPER_CLASS, " .project-block__block-element"));
                if (headingTextElement) {
                    var lineHeight = parseInt(window.getComputedStyle(headingTextElement).lineHeight, 10);
                    _this.buttonTopMargin = (lineHeight - BUTTON_HEIGHT) / 2;
                }
            };
            _this.containerRef = (_b = (_a = _this.props.attributes) === null || _a === void 0 ? void 0 : _a.ref) !== null && _b !== void 0 ? _b : react_1.default.createRef();
            return _this;
        }
        WithCentredButton.prototype.componentDidMount = function () {
            var _a;
            var containerRefElement = this.containerRef.current;
            if (containerRefElement) {
                this.containerRectObserver = (0, observe_rect_1.default)(containerRefElement, this.repositionButton);
                (_a = this.containerRectObserver) === null || _a === void 0 ? void 0 : _a.observe();
                this.repositionButton();
            }
        };
        WithCentredButton.prototype.componentWillUnmount = function () {
            var _a;
            (_a = this.containerRectObserver) === null || _a === void 0 ? void 0 : _a.unobserve();
        };
        WithCentredButton.prototype.render = function () {
            var props = __assign(__assign({}, this.props), { attributes: __assign(__assign({}, this.props.attributes), { ref: this.containerRef }), buttonTopMargin: this.buttonTopMargin });
            return react_1.default.createElement(Comp, __assign({}, props));
        };
        __decorate([
            mobx_1.observable.ref,
            __metadata("design:type", Object)
        ], WithCentredButton.prototype, "buttonTopMargin", void 0);
        __decorate([
            mobx_1.action,
            __metadata("design:type", Object)
        ], WithCentredButton.prototype, "repositionButton", void 0);
        WithCentredButton = __decorate([
            mobx_react_1.observer,
            __metadata("design:paramtypes", [Object])
        ], WithCentredButton);
        return WithCentredButton;
    }(react_1.default.Component));
    return WithCentredButton;
};
exports.default = withCentredAccordionButton;
